/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegistroRouteImport } from './routes/registro'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CheckAuthRouteImport } from './routes/_checkAuth'
import { Route as CheckAuthIndexRouteImport } from './routes/_checkAuth/index'
import { Route as CheckAuthReactivarCuentaRouteImport } from './routes/_checkAuth/reactivar-cuenta'
import { Route as CheckAuthLayoutRouteImport } from './routes/_checkAuth/_layout'
import { Route as CheckAuthReactivarCuentaCallbackRouteImport } from './routes/_checkAuth/reactivar-cuenta_/callback'
import { Route as CheckAuthPromosPromoSlugRouteImport } from './routes/_checkAuth/promos/$promoSlug'
import { Route as CheckAuthLayoutAsociateAhoraRouteImport } from './routes/_checkAuth/_layout/asociate-ahora'
import { Route as CheckAuthLayoutAuthenticatedRouteImport } from './routes/_checkAuth/_layout/_authenticated'
import { Route as CheckAuthLayoutBrandSlugRouteImport } from './routes/_checkAuth/_layout/$brandSlug'
import { Route as CheckAuthLayoutPeliculasMovieIdRouteImport } from './routes/_checkAuth/_layout/peliculas/$movieId'
import { Route as CheckAuthLayoutAuthenticatedAsociateRouteImport } from './routes/_checkAuth/_layout/_authenticated/asociate'
import { Route as CheckAuthLayoutAuthenticatedMemberRouteImport } from './routes/_checkAuth/_layout/_authenticated/_member'
import { Route as CheckAuthLayoutAuthenticatedAsociateMedioDePagoRouteImport } from './routes/_checkAuth/_layout/_authenticated/asociate_/medio-de-pago'
import { Route as CheckAuthLayoutAuthenticatedMemberLayoutRouteImport } from './routes/_checkAuth/_layout/_authenticated/_member/_layout'
import { Route as CheckAuthLayoutAuthenticatedMemberLayoutMiembrosRouteImport } from './routes/_checkAuth/_layout/_authenticated/_member/_layout/miembros'
import { Route as CheckAuthLayoutAuthenticatedMemberLayoutMiembrosPerfilRouteImport } from './routes/_checkAuth/_layout/_authenticated/_member/_layout/miembros_/perfil'
import { Route as CheckAuthLayoutAuthenticatedMemberLayoutMiembrosMedioDePagoRouteImport } from './routes/_checkAuth/_layout/_authenticated/_member/_layout/miembros_/medio-de-pago'
import { Route as CheckAuthLayoutAuthenticatedMemberLayoutMiembrosHistorialDeRecompensasRouteImport } from './routes/_checkAuth/_layout/_authenticated/_member/_layout/miembros_/historial-de-recompensas'

const RegistroRoute = RegistroRouteImport.update({
  id: '/registro',
  path: '/registro',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckAuthRoute = CheckAuthRouteImport.update({
  id: '/_checkAuth',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckAuthIndexRoute = CheckAuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CheckAuthRoute,
} as any)
const CheckAuthReactivarCuentaRoute =
  CheckAuthReactivarCuentaRouteImport.update({
    id: '/reactivar-cuenta',
    path: '/reactivar-cuenta',
    getParentRoute: () => CheckAuthRoute,
  } as any)
const CheckAuthLayoutRoute = CheckAuthLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => CheckAuthRoute,
} as any)
const CheckAuthReactivarCuentaCallbackRoute =
  CheckAuthReactivarCuentaCallbackRouteImport.update({
    id: '/reactivar-cuenta_/callback',
    path: '/reactivar-cuenta/callback',
    getParentRoute: () => CheckAuthRoute,
  } as any)
const CheckAuthPromosPromoSlugRoute =
  CheckAuthPromosPromoSlugRouteImport.update({
    id: '/promos/$promoSlug',
    path: '/promos/$promoSlug',
    getParentRoute: () => CheckAuthRoute,
  } as any)
const CheckAuthLayoutAsociateAhoraRoute =
  CheckAuthLayoutAsociateAhoraRouteImport.update({
    id: '/asociate-ahora',
    path: '/asociate-ahora',
    getParentRoute: () => CheckAuthLayoutRoute,
  } as any)
const CheckAuthLayoutAuthenticatedRoute =
  CheckAuthLayoutAuthenticatedRouteImport.update({
    id: '/_authenticated',
    getParentRoute: () => CheckAuthLayoutRoute,
  } as any)
const CheckAuthLayoutBrandSlugRoute =
  CheckAuthLayoutBrandSlugRouteImport.update({
    id: '/$brandSlug',
    path: '/$brandSlug',
    getParentRoute: () => CheckAuthLayoutRoute,
  } as any)
const CheckAuthLayoutPeliculasMovieIdRoute =
  CheckAuthLayoutPeliculasMovieIdRouteImport.update({
    id: '/peliculas/$movieId',
    path: '/peliculas/$movieId',
    getParentRoute: () => CheckAuthLayoutRoute,
  } as any)
const CheckAuthLayoutAuthenticatedAsociateRoute =
  CheckAuthLayoutAuthenticatedAsociateRouteImport.update({
    id: '/asociate',
    path: '/asociate',
    getParentRoute: () => CheckAuthLayoutAuthenticatedRoute,
  } as any)
const CheckAuthLayoutAuthenticatedMemberRoute =
  CheckAuthLayoutAuthenticatedMemberRouteImport.update({
    id: '/_member',
    getParentRoute: () => CheckAuthLayoutAuthenticatedRoute,
  } as any)
const CheckAuthLayoutAuthenticatedAsociateMedioDePagoRoute =
  CheckAuthLayoutAuthenticatedAsociateMedioDePagoRouteImport.update({
    id: '/asociate_/medio-de-pago',
    path: '/asociate/medio-de-pago',
    getParentRoute: () => CheckAuthLayoutAuthenticatedRoute,
  } as any)
const CheckAuthLayoutAuthenticatedMemberLayoutRoute =
  CheckAuthLayoutAuthenticatedMemberLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => CheckAuthLayoutAuthenticatedMemberRoute,
  } as any)
const CheckAuthLayoutAuthenticatedMemberLayoutMiembrosRoute =
  CheckAuthLayoutAuthenticatedMemberLayoutMiembrosRouteImport.update({
    id: '/miembros',
    path: '/miembros',
    getParentRoute: () => CheckAuthLayoutAuthenticatedMemberLayoutRoute,
  } as any)
const CheckAuthLayoutAuthenticatedMemberLayoutMiembrosPerfilRoute =
  CheckAuthLayoutAuthenticatedMemberLayoutMiembrosPerfilRouteImport.update({
    id: '/miembros_/perfil',
    path: '/miembros/perfil',
    getParentRoute: () => CheckAuthLayoutAuthenticatedMemberLayoutRoute,
  } as any)
const CheckAuthLayoutAuthenticatedMemberLayoutMiembrosMedioDePagoRoute =
  CheckAuthLayoutAuthenticatedMemberLayoutMiembrosMedioDePagoRouteImport.update(
    {
      id: '/miembros_/medio-de-pago',
      path: '/miembros/medio-de-pago',
      getParentRoute: () => CheckAuthLayoutAuthenticatedMemberLayoutRoute,
    } as any,
  )
const CheckAuthLayoutAuthenticatedMemberLayoutMiembrosHistorialDeRecompensasRoute =
  CheckAuthLayoutAuthenticatedMemberLayoutMiembrosHistorialDeRecompensasRouteImport.update(
    {
      id: '/miembros_/historial-de-recompensas',
      path: '/miembros/historial-de-recompensas',
      getParentRoute: () => CheckAuthLayoutAuthenticatedMemberLayoutRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof CheckAuthIndexRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/registro': typeof RegistroRoute
  '/reactivar-cuenta': typeof CheckAuthReactivarCuentaRoute
  '/$brandSlug': typeof CheckAuthLayoutBrandSlugRoute
  '/asociate-ahora': typeof CheckAuthLayoutAsociateAhoraRoute
  '/promos/$promoSlug': typeof CheckAuthPromosPromoSlugRoute
  '/reactivar-cuenta/callback': typeof CheckAuthReactivarCuentaCallbackRoute
  '/asociate': typeof CheckAuthLayoutAuthenticatedAsociateRoute
  '/peliculas/$movieId': typeof CheckAuthLayoutPeliculasMovieIdRoute
  '/asociate/medio-de-pago': typeof CheckAuthLayoutAuthenticatedAsociateMedioDePagoRoute
  '/miembros': typeof CheckAuthLayoutAuthenticatedMemberLayoutMiembrosRoute
  '/miembros/historial-de-recompensas': typeof CheckAuthLayoutAuthenticatedMemberLayoutMiembrosHistorialDeRecompensasRoute
  '/miembros/medio-de-pago': typeof CheckAuthLayoutAuthenticatedMemberLayoutMiembrosMedioDePagoRoute
  '/miembros/perfil': typeof CheckAuthLayoutAuthenticatedMemberLayoutMiembrosPerfilRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/registro': typeof RegistroRoute
  '/': typeof CheckAuthIndexRoute
  '/reactivar-cuenta': typeof CheckAuthReactivarCuentaRoute
  '/$brandSlug': typeof CheckAuthLayoutBrandSlugRoute
  '/asociate-ahora': typeof CheckAuthLayoutAsociateAhoraRoute
  '/promos/$promoSlug': typeof CheckAuthPromosPromoSlugRoute
  '/reactivar-cuenta/callback': typeof CheckAuthReactivarCuentaCallbackRoute
  '/asociate': typeof CheckAuthLayoutAuthenticatedAsociateRoute
  '/peliculas/$movieId': typeof CheckAuthLayoutPeliculasMovieIdRoute
  '/asociate/medio-de-pago': typeof CheckAuthLayoutAuthenticatedAsociateMedioDePagoRoute
  '/miembros': typeof CheckAuthLayoutAuthenticatedMemberLayoutMiembrosRoute
  '/miembros/historial-de-recompensas': typeof CheckAuthLayoutAuthenticatedMemberLayoutMiembrosHistorialDeRecompensasRoute
  '/miembros/medio-de-pago': typeof CheckAuthLayoutAuthenticatedMemberLayoutMiembrosMedioDePagoRoute
  '/miembros/perfil': typeof CheckAuthLayoutAuthenticatedMemberLayoutMiembrosPerfilRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_checkAuth': typeof CheckAuthRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/registro': typeof RegistroRoute
  '/_checkAuth/_layout': typeof CheckAuthLayoutRouteWithChildren
  '/_checkAuth/reactivar-cuenta': typeof CheckAuthReactivarCuentaRoute
  '/_checkAuth/': typeof CheckAuthIndexRoute
  '/_checkAuth/_layout/$brandSlug': typeof CheckAuthLayoutBrandSlugRoute
  '/_checkAuth/_layout/_authenticated': typeof CheckAuthLayoutAuthenticatedRouteWithChildren
  '/_checkAuth/_layout/asociate-ahora': typeof CheckAuthLayoutAsociateAhoraRoute
  '/_checkAuth/promos/$promoSlug': typeof CheckAuthPromosPromoSlugRoute
  '/_checkAuth/reactivar-cuenta_/callback': typeof CheckAuthReactivarCuentaCallbackRoute
  '/_checkAuth/_layout/_authenticated/_member': typeof CheckAuthLayoutAuthenticatedMemberRouteWithChildren
  '/_checkAuth/_layout/_authenticated/asociate': typeof CheckAuthLayoutAuthenticatedAsociateRoute
  '/_checkAuth/_layout/peliculas/$movieId': typeof CheckAuthLayoutPeliculasMovieIdRoute
  '/_checkAuth/_layout/_authenticated/_member/_layout': typeof CheckAuthLayoutAuthenticatedMemberLayoutRouteWithChildren
  '/_checkAuth/_layout/_authenticated/asociate_/medio-de-pago': typeof CheckAuthLayoutAuthenticatedAsociateMedioDePagoRoute
  '/_checkAuth/_layout/_authenticated/_member/_layout/miembros': typeof CheckAuthLayoutAuthenticatedMemberLayoutMiembrosRoute
  '/_checkAuth/_layout/_authenticated/_member/_layout/miembros_/historial-de-recompensas': typeof CheckAuthLayoutAuthenticatedMemberLayoutMiembrosHistorialDeRecompensasRoute
  '/_checkAuth/_layout/_authenticated/_member/_layout/miembros_/medio-de-pago': typeof CheckAuthLayoutAuthenticatedMemberLayoutMiembrosMedioDePagoRoute
  '/_checkAuth/_layout/_authenticated/_member/_layout/miembros_/perfil': typeof CheckAuthLayoutAuthenticatedMemberLayoutMiembrosPerfilRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/logout'
    | '/registro'
    | '/reactivar-cuenta'
    | '/$brandSlug'
    | '/asociate-ahora'
    | '/promos/$promoSlug'
    | '/reactivar-cuenta/callback'
    | '/asociate'
    | '/peliculas/$movieId'
    | '/asociate/medio-de-pago'
    | '/miembros'
    | '/miembros/historial-de-recompensas'
    | '/miembros/medio-de-pago'
    | '/miembros/perfil'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/logout'
    | '/registro'
    | '/'
    | '/reactivar-cuenta'
    | '/$brandSlug'
    | '/asociate-ahora'
    | '/promos/$promoSlug'
    | '/reactivar-cuenta/callback'
    | '/asociate'
    | '/peliculas/$movieId'
    | '/asociate/medio-de-pago'
    | '/miembros'
    | '/miembros/historial-de-recompensas'
    | '/miembros/medio-de-pago'
    | '/miembros/perfil'
  id:
    | '__root__'
    | '/_checkAuth'
    | '/login'
    | '/logout'
    | '/registro'
    | '/_checkAuth/_layout'
    | '/_checkAuth/reactivar-cuenta'
    | '/_checkAuth/'
    | '/_checkAuth/_layout/$brandSlug'
    | '/_checkAuth/_layout/_authenticated'
    | '/_checkAuth/_layout/asociate-ahora'
    | '/_checkAuth/promos/$promoSlug'
    | '/_checkAuth/reactivar-cuenta_/callback'
    | '/_checkAuth/_layout/_authenticated/_member'
    | '/_checkAuth/_layout/_authenticated/asociate'
    | '/_checkAuth/_layout/peliculas/$movieId'
    | '/_checkAuth/_layout/_authenticated/_member/_layout'
    | '/_checkAuth/_layout/_authenticated/asociate_/medio-de-pago'
    | '/_checkAuth/_layout/_authenticated/_member/_layout/miembros'
    | '/_checkAuth/_layout/_authenticated/_member/_layout/miembros_/historial-de-recompensas'
    | '/_checkAuth/_layout/_authenticated/_member/_layout/miembros_/medio-de-pago'
    | '/_checkAuth/_layout/_authenticated/_member/_layout/miembros_/perfil'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  CheckAuthRoute: typeof CheckAuthRouteWithChildren
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  RegistroRoute: typeof RegistroRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/registro': {
      id: '/registro'
      path: '/registro'
      fullPath: '/registro'
      preLoaderRoute: typeof RegistroRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_checkAuth': {
      id: '/_checkAuth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof CheckAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_checkAuth/': {
      id: '/_checkAuth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof CheckAuthIndexRouteImport
      parentRoute: typeof CheckAuthRoute
    }
    '/_checkAuth/reactivar-cuenta': {
      id: '/_checkAuth/reactivar-cuenta'
      path: '/reactivar-cuenta'
      fullPath: '/reactivar-cuenta'
      preLoaderRoute: typeof CheckAuthReactivarCuentaRouteImport
      parentRoute: typeof CheckAuthRoute
    }
    '/_checkAuth/_layout': {
      id: '/_checkAuth/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof CheckAuthLayoutRouteImport
      parentRoute: typeof CheckAuthRoute
    }
    '/_checkAuth/reactivar-cuenta_/callback': {
      id: '/_checkAuth/reactivar-cuenta_/callback'
      path: '/reactivar-cuenta/callback'
      fullPath: '/reactivar-cuenta/callback'
      preLoaderRoute: typeof CheckAuthReactivarCuentaCallbackRouteImport
      parentRoute: typeof CheckAuthRoute
    }
    '/_checkAuth/promos/$promoSlug': {
      id: '/_checkAuth/promos/$promoSlug'
      path: '/promos/$promoSlug'
      fullPath: '/promos/$promoSlug'
      preLoaderRoute: typeof CheckAuthPromosPromoSlugRouteImport
      parentRoute: typeof CheckAuthRoute
    }
    '/_checkAuth/_layout/asociate-ahora': {
      id: '/_checkAuth/_layout/asociate-ahora'
      path: '/asociate-ahora'
      fullPath: '/asociate-ahora'
      preLoaderRoute: typeof CheckAuthLayoutAsociateAhoraRouteImport
      parentRoute: typeof CheckAuthLayoutRoute
    }
    '/_checkAuth/_layout/_authenticated': {
      id: '/_checkAuth/_layout/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof CheckAuthLayoutAuthenticatedRouteImport
      parentRoute: typeof CheckAuthLayoutRoute
    }
    '/_checkAuth/_layout/$brandSlug': {
      id: '/_checkAuth/_layout/$brandSlug'
      path: '/$brandSlug'
      fullPath: '/$brandSlug'
      preLoaderRoute: typeof CheckAuthLayoutBrandSlugRouteImport
      parentRoute: typeof CheckAuthLayoutRoute
    }
    '/_checkAuth/_layout/peliculas/$movieId': {
      id: '/_checkAuth/_layout/peliculas/$movieId'
      path: '/peliculas/$movieId'
      fullPath: '/peliculas/$movieId'
      preLoaderRoute: typeof CheckAuthLayoutPeliculasMovieIdRouteImport
      parentRoute: typeof CheckAuthLayoutRoute
    }
    '/_checkAuth/_layout/_authenticated/asociate': {
      id: '/_checkAuth/_layout/_authenticated/asociate'
      path: '/asociate'
      fullPath: '/asociate'
      preLoaderRoute: typeof CheckAuthLayoutAuthenticatedAsociateRouteImport
      parentRoute: typeof CheckAuthLayoutAuthenticatedRoute
    }
    '/_checkAuth/_layout/_authenticated/_member': {
      id: '/_checkAuth/_layout/_authenticated/_member'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof CheckAuthLayoutAuthenticatedMemberRouteImport
      parentRoute: typeof CheckAuthLayoutAuthenticatedRoute
    }
    '/_checkAuth/_layout/_authenticated/asociate_/medio-de-pago': {
      id: '/_checkAuth/_layout/_authenticated/asociate_/medio-de-pago'
      path: '/asociate/medio-de-pago'
      fullPath: '/asociate/medio-de-pago'
      preLoaderRoute: typeof CheckAuthLayoutAuthenticatedAsociateMedioDePagoRouteImport
      parentRoute: typeof CheckAuthLayoutAuthenticatedRoute
    }
    '/_checkAuth/_layout/_authenticated/_member/_layout': {
      id: '/_checkAuth/_layout/_authenticated/_member/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof CheckAuthLayoutAuthenticatedMemberLayoutRouteImport
      parentRoute: typeof CheckAuthLayoutAuthenticatedMemberRoute
    }
    '/_checkAuth/_layout/_authenticated/_member/_layout/miembros': {
      id: '/_checkAuth/_layout/_authenticated/_member/_layout/miembros'
      path: '/miembros'
      fullPath: '/miembros'
      preLoaderRoute: typeof CheckAuthLayoutAuthenticatedMemberLayoutMiembrosRouteImport
      parentRoute: typeof CheckAuthLayoutAuthenticatedMemberLayoutRoute
    }
    '/_checkAuth/_layout/_authenticated/_member/_layout/miembros_/perfil': {
      id: '/_checkAuth/_layout/_authenticated/_member/_layout/miembros_/perfil'
      path: '/miembros/perfil'
      fullPath: '/miembros/perfil'
      preLoaderRoute: typeof CheckAuthLayoutAuthenticatedMemberLayoutMiembrosPerfilRouteImport
      parentRoute: typeof CheckAuthLayoutAuthenticatedMemberLayoutRoute
    }
    '/_checkAuth/_layout/_authenticated/_member/_layout/miembros_/medio-de-pago': {
      id: '/_checkAuth/_layout/_authenticated/_member/_layout/miembros_/medio-de-pago'
      path: '/miembros/medio-de-pago'
      fullPath: '/miembros/medio-de-pago'
      preLoaderRoute: typeof CheckAuthLayoutAuthenticatedMemberLayoutMiembrosMedioDePagoRouteImport
      parentRoute: typeof CheckAuthLayoutAuthenticatedMemberLayoutRoute
    }
    '/_checkAuth/_layout/_authenticated/_member/_layout/miembros_/historial-de-recompensas': {
      id: '/_checkAuth/_layout/_authenticated/_member/_layout/miembros_/historial-de-recompensas'
      path: '/miembros/historial-de-recompensas'
      fullPath: '/miembros/historial-de-recompensas'
      preLoaderRoute: typeof CheckAuthLayoutAuthenticatedMemberLayoutMiembrosHistorialDeRecompensasRouteImport
      parentRoute: typeof CheckAuthLayoutAuthenticatedMemberLayoutRoute
    }
  }
}

interface CheckAuthLayoutAuthenticatedMemberLayoutRouteChildren {
  CheckAuthLayoutAuthenticatedMemberLayoutMiembrosRoute: typeof CheckAuthLayoutAuthenticatedMemberLayoutMiembrosRoute
  CheckAuthLayoutAuthenticatedMemberLayoutMiembrosHistorialDeRecompensasRoute: typeof CheckAuthLayoutAuthenticatedMemberLayoutMiembrosHistorialDeRecompensasRoute
  CheckAuthLayoutAuthenticatedMemberLayoutMiembrosMedioDePagoRoute: typeof CheckAuthLayoutAuthenticatedMemberLayoutMiembrosMedioDePagoRoute
  CheckAuthLayoutAuthenticatedMemberLayoutMiembrosPerfilRoute: typeof CheckAuthLayoutAuthenticatedMemberLayoutMiembrosPerfilRoute
}

const CheckAuthLayoutAuthenticatedMemberLayoutRouteChildren: CheckAuthLayoutAuthenticatedMemberLayoutRouteChildren =
  {
    CheckAuthLayoutAuthenticatedMemberLayoutMiembrosRoute:
      CheckAuthLayoutAuthenticatedMemberLayoutMiembrosRoute,
    CheckAuthLayoutAuthenticatedMemberLayoutMiembrosHistorialDeRecompensasRoute:
      CheckAuthLayoutAuthenticatedMemberLayoutMiembrosHistorialDeRecompensasRoute,
    CheckAuthLayoutAuthenticatedMemberLayoutMiembrosMedioDePagoRoute:
      CheckAuthLayoutAuthenticatedMemberLayoutMiembrosMedioDePagoRoute,
    CheckAuthLayoutAuthenticatedMemberLayoutMiembrosPerfilRoute:
      CheckAuthLayoutAuthenticatedMemberLayoutMiembrosPerfilRoute,
  }

const CheckAuthLayoutAuthenticatedMemberLayoutRouteWithChildren =
  CheckAuthLayoutAuthenticatedMemberLayoutRoute._addFileChildren(
    CheckAuthLayoutAuthenticatedMemberLayoutRouteChildren,
  )

interface CheckAuthLayoutAuthenticatedMemberRouteChildren {
  CheckAuthLayoutAuthenticatedMemberLayoutRoute: typeof CheckAuthLayoutAuthenticatedMemberLayoutRouteWithChildren
}

const CheckAuthLayoutAuthenticatedMemberRouteChildren: CheckAuthLayoutAuthenticatedMemberRouteChildren =
  {
    CheckAuthLayoutAuthenticatedMemberLayoutRoute:
      CheckAuthLayoutAuthenticatedMemberLayoutRouteWithChildren,
  }

const CheckAuthLayoutAuthenticatedMemberRouteWithChildren =
  CheckAuthLayoutAuthenticatedMemberRoute._addFileChildren(
    CheckAuthLayoutAuthenticatedMemberRouteChildren,
  )

interface CheckAuthLayoutAuthenticatedRouteChildren {
  CheckAuthLayoutAuthenticatedMemberRoute: typeof CheckAuthLayoutAuthenticatedMemberRouteWithChildren
  CheckAuthLayoutAuthenticatedAsociateRoute: typeof CheckAuthLayoutAuthenticatedAsociateRoute
  CheckAuthLayoutAuthenticatedAsociateMedioDePagoRoute: typeof CheckAuthLayoutAuthenticatedAsociateMedioDePagoRoute
}

const CheckAuthLayoutAuthenticatedRouteChildren: CheckAuthLayoutAuthenticatedRouteChildren =
  {
    CheckAuthLayoutAuthenticatedMemberRoute:
      CheckAuthLayoutAuthenticatedMemberRouteWithChildren,
    CheckAuthLayoutAuthenticatedAsociateRoute:
      CheckAuthLayoutAuthenticatedAsociateRoute,
    CheckAuthLayoutAuthenticatedAsociateMedioDePagoRoute:
      CheckAuthLayoutAuthenticatedAsociateMedioDePagoRoute,
  }

const CheckAuthLayoutAuthenticatedRouteWithChildren =
  CheckAuthLayoutAuthenticatedRoute._addFileChildren(
    CheckAuthLayoutAuthenticatedRouteChildren,
  )

interface CheckAuthLayoutRouteChildren {
  CheckAuthLayoutBrandSlugRoute: typeof CheckAuthLayoutBrandSlugRoute
  CheckAuthLayoutAuthenticatedRoute: typeof CheckAuthLayoutAuthenticatedRouteWithChildren
  CheckAuthLayoutAsociateAhoraRoute: typeof CheckAuthLayoutAsociateAhoraRoute
  CheckAuthLayoutPeliculasMovieIdRoute: typeof CheckAuthLayoutPeliculasMovieIdRoute
}

const CheckAuthLayoutRouteChildren: CheckAuthLayoutRouteChildren = {
  CheckAuthLayoutBrandSlugRoute: CheckAuthLayoutBrandSlugRoute,
  CheckAuthLayoutAuthenticatedRoute:
    CheckAuthLayoutAuthenticatedRouteWithChildren,
  CheckAuthLayoutAsociateAhoraRoute: CheckAuthLayoutAsociateAhoraRoute,
  CheckAuthLayoutPeliculasMovieIdRoute: CheckAuthLayoutPeliculasMovieIdRoute,
}

const CheckAuthLayoutRouteWithChildren = CheckAuthLayoutRoute._addFileChildren(
  CheckAuthLayoutRouteChildren,
)

interface CheckAuthRouteChildren {
  CheckAuthLayoutRoute: typeof CheckAuthLayoutRouteWithChildren
  CheckAuthReactivarCuentaRoute: typeof CheckAuthReactivarCuentaRoute
  CheckAuthIndexRoute: typeof CheckAuthIndexRoute
  CheckAuthPromosPromoSlugRoute: typeof CheckAuthPromosPromoSlugRoute
  CheckAuthReactivarCuentaCallbackRoute: typeof CheckAuthReactivarCuentaCallbackRoute
}

const CheckAuthRouteChildren: CheckAuthRouteChildren = {
  CheckAuthLayoutRoute: CheckAuthLayoutRouteWithChildren,
  CheckAuthReactivarCuentaRoute: CheckAuthReactivarCuentaRoute,
  CheckAuthIndexRoute: CheckAuthIndexRoute,
  CheckAuthPromosPromoSlugRoute: CheckAuthPromosPromoSlugRoute,
  CheckAuthReactivarCuentaCallbackRoute: CheckAuthReactivarCuentaCallbackRoute,
}

const CheckAuthRouteWithChildren = CheckAuthRoute._addFileChildren(
  CheckAuthRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  CheckAuthRoute: CheckAuthRouteWithChildren,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  RegistroRoute: RegistroRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
